import React from "react";
import { useRef, useEffect, useState } from "react";
import "./OnlineBooking.css"
import {
  GetConfig,
  GetPaymentServiceDetails,
  UpdateTerms
} from './Requests';
import {PulseLoader } from "react-spinners";
import Payments from "./Payments";
import Details from "./Details";
import { ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  notifyError,
  notifySuccess
} from '../Response/ResposeHandler'

const OnlineBooking = (props) => {
    const [tab, setTab] = useState("Payments")
    const [isLoading, setIsLoading] = useState(true)
    const [config, setConfig] = useState()
    const [enabledOnlinePaymentsButton, setEnableOnlinePaymentsButtons] = useState(false)
    const [tAndCuttonLoading, setTAndCuttonLoading] = useState(false)
    const [status , setStatus] = useState("null")
    const [paymentServiceDetails, setPaymentServiceDetails] = useState()
    const [terms, setTerms] = useState()
    
        useEffect(() => {
            GetConfigWrapper()
        }, []);
    
      function GetConfigWrapper() {
        // setIsLoading(true)
        GetConfig().then((res) => {
            // setIsLoading(true)
            setConfig(res.data)
            setEnableOnlinePaymentsButtons(res.data.acceptOnlinePayments)
            setTerms(res.data.terms)
            if (!res.data.payoutsEnabled)
            {
                setStatus("no payouts")
            }
            if (!res.data.chargesEnabled)
            {
                setStatus("no charges")
            }
            if (res.data.payoutsEnabled && res.data.chargesEnabled)
            {
                setStatus("Connected")
            }
        }).catch((error) => {
        //   notifyError("Unable to retrieve config settings, please try again")
        }).finally(() => {
          GetPaymentServiceDetailsWrapper()

        })
      }
    
        function GetPaymentServiceDetailsWrapper()
        {
          GetPaymentServiceDetails().then((res) => {
            if (res.status === 200)
            {
              setPaymentServiceDetails(res.data)
            }
            setIsLoading(false)
          })
        }

function SubmitTerms()
{
    UpdateTerms(terms).then((res) => {
      if (res.status === 200)
      {
        notifySuccess("Saved")
      }
    }).catch((e) => {
      notifyError("There was an issue saving the terms and conditions, please try again or contact support")
    })
}

    const renderTabs = () => {
       switch (tab.toLowerCase()) {
         case "payments":
        return (
            <Payments getConfig={GetConfigWrapper} paymentServiceDetails={paymentServiceDetails} status={status} config={config}/>
        );
         case "details":
           return (
             <main>
              <h1>Details</h1>
               <Details config={config} getConfig={GetConfigWrapper}/>
           </main>
           );
         case "t&cs":
           return (
            <div>
               <main>
                  <h3>Terms and Conditions</h3>
                    <label>Specify any Terms and Conditions that you might like to inform your customers of when booking appointments with you</label>
                    <textarea
                        onChange={(e) => {setTerms(e.target.value)}}
                        maxLength={500}
                        rows="4"
                        type="textarea"
                        placeholder=""
                        value={terms}
                        />
                    <button disabled={tAndCuttonLoading} onClick={SubmitTerms} style={{marginTop:0, marginTop:"2rem"}} className='save-button button'>
                        {!tAndCuttonLoading ?
                        "Save":
                        <PulseLoader 
                            color={'#eee'}
                            loading={tAndCuttonLoading}
                            size={10}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        }
                    </button>
               </main>
            </div>
           );
         default:
           return null;
       }
     };


   return (

    <div>
      <ToastContainer />
      {
      isLoading ? <div className='barber-loader'></div>:
      <div style={{marginTop:0, paddingTop:0}} className="container">
     <div className="sub-nav" style={{marginTop:0}}>
         {['Payments', 'Details', 'T&Cs'].map(tabOption => (
             <a
             key={tabOption}
             href="#"
             className={`sub-tab ${tab === tabOption ? "active" : ""}`}
             onClick={() => setTab(tabOption)}
             >
             {tabOption}
             </a>
         ))}
              </div>
        {renderTabs()}
      </div>
      }
    </div>

   );
};

export default OnlineBooking;
